export const PANEL_PERMISSIONS = [
  { key: 'cleaning', label: 'Sprzątanie', description: 'Dostęp do panelu sprzątania i checklist' },
  { key: 'reservations', label: 'Rezerwacje', description: 'Dostęp do listy rezerwacji i szczegółów pobytów' },
  { key: 'billing', label: 'Rachunki', description: 'Dostęp do panelu rachunków dla gości' },
  { key: 'messages', label: 'Wiadomości', description: 'Dostęp do panelu wiadomości od gości' },
  { key: 'expenses', label: 'Zakupy', description: 'Dostęp do zakupów, paragonów i zwrotów' },
  { key: 'finance', label: 'Finanse', description: 'Dostęp do podsumowania przychodów i kosztów' },
  { key: 'integrations', label: 'Integracje', description: 'Dostęp do importów i integracji' },
  { key: 'health', label: 'Health', description: 'Dostęp do stanu usług, workerów i alertów' },
  { key: 'nuki', label: 'Nuki', description: 'Dostęp do panelu Nuki i historii wejść' },
  { key: 'agent', label: 'Agent', description: 'Dostęp do panelu agenta i podsumowań AI' },
  { key: 'users', label: 'Użytkownicy', description: 'Dostęp do zarządzania użytkownikami i ich uprawnieniami' },
];

export const PANEL_PERMISSION_MAP = Object.fromEntries(PANEL_PERMISSIONS.map((item) => [item.key, item]));

export const DEFAULT_PERMISSIONS = Object.fromEntries(PANEL_PERMISSIONS.map((item) => [item.key, {
  label: item.label,
  description: item.description,
}]));

export function getUserPermissions(user) {
  if (user?.role === 'admin') {
    return PANEL_PERMISSIONS.map((item) => item.key);
  }
  return Array.isArray(user?.permissions) ? user.permissions : [];
}

export function hasPermission(user, permission) {
  if (!permission) return true;
  if (user?.role === 'admin') return true;
  return getUserPermissions(user).includes(permission);
}

export function firstAllowedPath(user) {
  if (user?.role === 'admin') return '/dashboard';
  const order = [
    ['cleaning', '/sprzatanie'],
    ['reservations', '/rezerwacje'],
    ['billing', '/rachunki'],
    ['messages', '/wiadomosci'],
    ['expenses', '/zakupy'],
    ['finance', '/finanse'],
    ['integrations', '/import'],
    ['health', '/health'],
    ['nuki', '/nuki'],
    ['agent', '/agent'],
    ['users', '/uzytkownicy'],
  ];
  return order.find(([permission]) => hasPermission(user, permission))?.[1] || '/brak-dostepu';
}

export const ROUTE_PERMISSIONS = [
  { prefix: '/sprzatanie', permission: 'cleaning' },
  { prefix: '/rezerwacje', permission: 'reservations' },
  { prefix: '/rachunki', permission: 'billing' },
  { prefix: '/wiadomosci', permission: 'messages' },
  { prefix: '/zakupy', permission: 'expenses' },
  { prefix: '/finanse', permission: 'finance' },
  { prefix: '/import', permission: 'integrations' },
  { prefix: '/health', permission: 'health' },
  { prefix: '/nuki', permission: 'nuki' },
  { prefix: '/agent', permission: 'agent' },
  { prefix: '/uzytkownicy', permission: 'users' },
];

export function requiredPermissionForPath(pathname = '') {
  return ROUTE_PERMISSIONS.find((item) => pathname === item.prefix || pathname.startsWith(`${item.prefix}/`))?.permission || null;
}
